import type { State } from '../../interfaces/State';
import type { ImagesState } from '../reducers/images';

export const selectImages = (state: State): ImagesState => state.get('images');
